import { noiseDefinition, type NoiseParameters } from "../../core/effects/noise";

type NoiseControlsProps = {
  parameters: NoiseParameters;
  onChange: (patch: Partial<NoiseParameters>) => void;
  onReset: () => void;
};

export function NoiseControls({ parameters, onChange, onReset }: NoiseControlsProps) {
  return (
    <div className="effect-controls">
      <div className="effect-controls__head">
        <div>
          <div className="panel-label">Controls</div>
          <strong>{noiseDefinition.name}</strong>
        </div>
        <button type="button" onClick={onReset}>Reset</button>
      </div>

      <label>
        <span>Amount <b>{Math.round(parameters.amount * 100)}%</b></span>
        <input type="range" min="0" max="1" step="0.01" value={parameters.amount} onChange={(event) => onChange({ amount: Number(event.target.value) })} />
      </label>
      <label className="control-row control-row--toggle">
        <span>Monochrome</span>
        <input type="checkbox" checked={parameters.monochrome} onChange={(event) => onChange({ monochrome: event.target.checked })} />
      </label>
      <label>
        <span>Seed <b>{parameters.seed}</b></span>
        <input type="number" min="0" max="9999" step="1" value={parameters.seed} onChange={(event) => onChange({ seed: Number(event.target.value) })} />
      </label>
    </div>
  );
}
